import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../auth-config';
import { environment } from '../../../environments/environment';
import {
  buildLocalStorageKeyMaterial,
  deriveLocalStorageEncryptionKey,
} from './local-storage-crypto.util';
import {
  setLocalStorageEncryptionKey,
  warnLocalStorageEncryption,
} from './local-storage-key-state.util';
import { migrateAllPlainLocalStorageKeys } from './local-storage-native.util';

/**
 * Derive the encryption key from the MSAL account cache before Angular boot
 * so feature code never writes PacTrak keys in plain text on hard reload.
 */
export async function bootstrapLocalStorageEncryptionFromMsal(): Promise<void> {
  try {
    const msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();

    const account =
      msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

    if (!account) {
      return;
    }

    if (!msalInstance.getActiveAccount()) {
      msalInstance.setActiveAccount(account);
    }

    const material = buildLocalStorageKeyMaterial(
      account.homeAccountId ?? '',
      account.localAccountId ?? '',
      environment.clientId
    );
    setLocalStorageEncryptionKey(deriveLocalStorageEncryptionKey(material));
    migrateAllPlainLocalStorageKeys();
  } catch (error) {
    warnLocalStorageEncryption(
      'Pre-Angular MSAL bootstrap failed; key init deferred to auth flow',
      { error: error instanceof Error ? error.message : String(error) }
    );
  }
}
